import React, { useEffect } from 'react';

import classes from './Article.module.scss';
import { getFileName } from 'helpers/FileCaching';
import { Helmet } from "react-helmet";
import Footer from 'components/Shared/Footer/Footer';
//Images
const socialImages = require.context('assets/images/Article/Social', true, /.*\.(gif|png|jpe?g|svg)$/i);

const Article = ({content, windowSize, globalContent}) => {

    const components = (content
                            ?
                            content.body.map((data, index) => {
                                return(
                                    React.cloneElement(
                                        data.component,
                                        {content: data.content, key:index, windowSize:windowSize, author:content.author}
                                    )
                                )
                            })
                            :
                            ""
                        );

    const getMetaImage = (localImageFilePath) => {

        let socialImageStr = String(getFileName(socialImages, localImageFilePath))
        let base64Check = socialImageStr.match(/data:image/gi) !== null

        socialImageStr = socialImageStr.substring(1)

        if(base64Check){
            return socialImageStr
        }else{
            return globalContent.liveUrlDomain+socialImageStr
        }

    }



    const pageMeta = (content
        ?
        <Helmet
            title={content.meta.pageTitle}
            meta={
                [
                    {
                        name: "fb:app_id",
                        content: globalContent.social.fb_app_id
                    },
                    {
                        name: "keywords",
                        content: ""
                    },
                    {
                        name: "description",
                        content: content.meta.pageDescription
                    },
                    {
                        property: "og:url",
                        content: globalContent.liveUrl+content.url
                    },
                    {
                        property: "og:type",
                        content: "article"
                    },
                    {
                        property: "og:title",
                        content: content.meta.og.pageTitle
                    },
                    {
                        property: "og:description",
                        content: content.meta.og.pageDescription
                    },
                    {
                        property: "og:image",
                        content: getMetaImage(content.meta.og.image)
                    },
                    {
                        property: "twitter:card",
                        content: "summary_large_image"
                    },
                    {
                        property: "twitter:site",
                        content: "@BBC_Future"
                    },								
                    {
                        property: "twitter:title",
                        content: content.meta.og.pageTitle
                    },
                    {
                        property: "twitter:description",
                        content: content.meta.og.pageDescription
                    },
                    {
                        property: "twitter:image",
                        content: getMetaImage(content.meta.twitter.image)
                    }
                ]
            }
        />
        :
        ""
    )

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

	return(
		<>
            {pageMeta}
			{components}
            {
                (
                    components !== ""
                    ?
                    <Footer />
                    :
                    ""
                )
            }
		</>
	)

}

export default Article;